import React, { useEffect } from "react";
import {
  ASSESSMENT_CHANNEL_NAME,
  registerAssessmentEvent,
  registerAssessmentSocketConnected,
  unRegisterAssessmentEvent,
} from "../../../../store/services/assessmentSocket.service";
import { fetchAssessment } from "../../../../store/actions/assessment.action";
import { fetchAssessmentResponces } from "../../../../store/actions/questionAnswer.action";

import { useDispatch } from "react-redux";

export default function AssessmentListEvent() {
  const dispatch = useDispatch();

  const handleAssessmentListChange = (data) => {
    const classId = JSON.parse(sessionStorage.getItem("classinfo")).kneuraId;
    const studentId = localStorage.getItem("kneuraId");
    dispatch(fetchAssessment(classId));
    dispatch(fetchAssessmentResponces(classId, studentId));
  };

  const handleAssessmentSocketConnected = () => {
    registerAssessmentEvent(
      ASSESSMENT_CHANNEL_NAME.ASSESSMENT_PUBLISHED,
      handleAssessmentListChange
    );

    registerAssessmentEvent(
      ASSESSMENT_CHANNEL_NAME.ASSESSMENT_ROLL_BACK,
      handleAssessmentListChange
    );
  };

  useEffect(() => {
    registerAssessmentSocketConnected(handleAssessmentSocketConnected);


    return () => {

      unRegisterAssessmentEvent(
        ASSESSMENT_CHANNEL_NAME.ASSESSMENT_PUBLISHED,
        handleAssessmentListChange
      );

      unRegisterAssessmentEvent(
        ASSESSMENT_CHANNEL_NAME.ASSESSMENT_ROLL_BACK,
        handleAssessmentListChange
      );
    };
  }, []);

  return <></>;
}
